import { createElement } from 'react';

import { createRoot } from 'react-dom/client';

import Calculator from '@cc/calculator';

const initOnPageCalculator = ({ el, calculatorId }) => {
    const isLazy = el.hasAttribute('data-lazy');
    const isVisible = el.checkVisibility?.() ?? true;

    if (isLazy && !isVisible) {
        scheduleRenderCalculator({ el, calculatorId });
    } else {
        renderCalculator({ el, calculatorId });
    }
};

const renderCalculator = ({ el, calculatorId }) => {
    // First unmount existing calculator before rendering calculator.
    // This is important for the reload() function.
    createRoot(el).unmount();

    // Once you call root.unmount you cannot call root.render again on the same root
    // https://beta.reactjs.org/reference/react-dom/client/createRoot
    // So we need to create a fresh root instead of reusing the one above
    const root = createRoot(el);

    const CalculatorElement = createElement(Calculator, {
        calculatorId,
        embedType: 'inPage',
    });

    root.render(CalculatorElement);
};

const scheduleRenderCalculator = ({ el, calculatorId }) => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    observer.disconnect();
                    renderCalculator({ el, calculatorId });
                }
            });
        },
        {
            root: null,
            rootMargin: '0px',
            threshold: 0.1,
        }
    );

    observer.observe(el);
};

export default initOnPageCalculator;
